import { render, staticRenderFns } from "./SecurityNoticeModal.vue?vue&type=template&id=65fdd56f"
import script from "./SecurityNoticeModal.vue?vue&type=script&lang=js"
export * from "./SecurityNoticeModal.vue?vue&type=script&lang=js"
import style0 from "./SecurityNoticeModal.vue?vue&type=style&index=0&id=65fdd56f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports